document.addEventListener('DOMContentLoaded', () => {
   const toggle = document.querySelector('.wcl-single-tools-hero__specs-toggle');
   if (!toggle) return;

   toggle.addEventListener('click', () => {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      const hiddenItems = document.querySelectorAll('.wcl-single-tools-hero__specs-item--hidden');

      hiddenItems.forEach(item => item.classList.toggle('is-visible', !isExpanded));

      toggle.setAttribute('aria-expanded', String(!isExpanded));
      toggle.textContent = isExpanded ? 'Show More Specs' : 'Show Less Specs';
   });
});